// extracted by mini-css-extract-plugin
export default {"inbox":"Inbox__inbox--2Zf","inboxIcon":"Inbox__inboxIcon--Yd0"};